import { render, staticRenderFns } from "./ApplicationPending.vue?vue&type=template&id=70dd34f8&"
import script from "./ApplicationPending.vue?vue&type=script&lang=js&"
export * from "./ApplicationPending.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationPending.vue?vue&type=style&index=0&id=70dd34f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports